
  import { Icon } from '@/ui/components/icon/Icon';
  import { defineComponent } from 'vue';

  export default defineComponent({
    components: {
      Icon,
    },
  });
